module.exports = __webpack_public_path__ + "static/media/app-of.07dd307b.png";